module.exports = __webpack_public_path__ + "static/media/9.c6af7e1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instructorsPhoto/9.jpg
// module id = 250
// module chunks = 1